<template>
  <div class="col-sm-12 text-center">
    <h4 v-if="gbgverified">
      You've now been assigned to one of our specialist account managers, you
      will have received an email with details of your account and your account
      manager. Please select a time and date below to book in your initial
      consultation.
    </h4>
    <h4 class="info-text" v-else>
      In order to complete your registration, we would like you to book an
      initial consultation with one of our specialists to help us further
      understand your requirements and how we can assist you.
    </h4>

    <div class="form-group flex-content-center">
      <!-- <label class="form-label">Date</label> -->
      <date-picker
        v-model="dateValue"
        format="DD/MM/YYYY"
        type="date"
        placeholder="Select date"
        :disabled-date="disabledBeforeToday"
        @pick="onSelect"
      ></date-picker>
    </div>
    <div class="form-group flex-content-center">
      <date-picker
        v-model="timeValue"
        :time-picker-options="{
          start: '09:00',
          step: '00:30',
          end: '16:30',
        }"
        :disabled-time="disableTimeSlots"
        format="hh:mm a"
        type="time"
        placeholder="Select time"
         :disabled="loading"
      ></date-picker>
    </div>
    <div class="col-sm-12">
      <message-info />
    </div>
    <div class="col-sm-12 mt-3 mb-3 " v-if="showSubmit">
      <input
        type="button"
        class="btn btn-next btn-fill btn-success btn-wd btn-md"
        name="save"
        value="Call back"
        @click.prevent="bookAppointment()"
      />
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import MessageInfo from "@/components/ui/MessageInfo.vue";
import mixin from "@/components/shared/mixinUtility";
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "DateTimePicker",
  props: ["gbgverified"],
  mixins: [mixin],
  components: { "date-picker": DatePicker, "message-info": MessageInfo },
  ...mapGetters({
    contactId: "getContactId",
    jwtToken: "getJwtToken",
  }),
  computed:{
    getTimeSlot(){
      if (this.timeValue)
        return moment(
            this.timeValue
          ).format("HH:mm");
      else
      return null
    },
    selectedSlot(){
      //find slot info
      if (this.slots.length && this.getTimeSlot){
        let found = this.slots.filter((s)=>{return s.startTime == this.getTimeSlot})[0];
        return found;
      }
      return null;
    }
  },
  data() {
    return {
      dateValue: null,
      timeValue: null,
      traderId:null,
      slots:[],
      disabledSlots: [],
      showSubmit:true,
        loading:false
    };
  },
  methods: {
    onSelect(date) {
      console.log(date);
       //clear time
      this.timeValue = null;
      this.getAvailability();
    },
    disableTimeSlots(date) {
      let slots = this.disabledSlots;
      let condition=null;
      slots.forEach((el) => {
        let starHour = parseInt(el.startTime.split(":")[0]);
        let startMinute =
          el.startTime.split(":")[1] == "00"
            ? 0
            : parseInt(el.startTime.split(":")[1]);
        let endHour = parseInt(el.endTime.split(":")[0]);
        let endMinute =
          el.endTime.split(":")[1] == "00"
            ? 0
            : parseInt(el.endTime.split(":")[1]);
      //  console.log(starHour, startMinute, endHour, endMinute);
        if (condition != null)
          condition =
            condition ||
            (date >=
              new Date(new Date().setHours(starHour, startMinute, 0, 0)) &&
              date < new Date(new Date().setHours(endHour, endMinute, 0, 0)));
        else
          condition =
            date >= new Date(new Date().setHours(starHour, startMinute, 0, 0)) &&
            date < new Date(new Date().setHours(endHour, endMinute, 0, 0));
      });
      return condition;
    },
    bookAppointment() {
      this.resetMessageInfo();

      if (this.dateValue == null || this.timeValue == null) {
        this.showGenericErrorMessage("Please select a valid date/time.", false);
        return false;
      }
      //book call
       this.callBackApi();
       //if gbg failed
      if (!this.isGBGVerified) {
        this.$emit("goNext");
      } else {
        this.showGenericErrorMessage(
          "Thank you for requesting a call back with us.",
          true
        );
        //hide submit button
        this.showSubmit=false;
      }

    },
    callBackApi(){
      const payload = {
        contactId: this.contactId,
        traderId: this.selectedSlot.traderID,
        groupId:this.selectedSlot.groupID,
        dateSelected: moment(
            this.dateValue
          ).format("YYYY-MM-DD"),
        timeSlot: this.selectedSlot.startTime+" - " +this.selectedSlot.endTime
      };

     axios.post(
        process.env.VUE_APP_API_URL + "/client/BookCallBack",
        payload,
         { headers: { Authorization: `Bearer ${this.jwtToken}` } }
      );
    },
    async getAvailability() {
      if (this.dateValue == null) return false;

      try{
           this.loading=true;
      const res = await axios.get(
        process.env.VUE_APP_API_URL +
          `/client/GetAvailableTimeSlots?contactId=${this.contactId}&date=${moment(
            this.dateValue
          ).format("YYYY-MM-DD")}&bizId=22`
      );
   
      const slots = res.data.data.timeslot;
      this.slots=[];
       this.slots=slots;
      //let availableSlots = slots.data.filter((s) => s.status == "available");
      let busySlots = slots.filter((s) => s.status == "busy");
      if (busySlots.length > 0) {
        this.disabledSlots = busySlots;
        this.disableTimeSlots(new Date());
      }
         this.loading=false;
      }catch(e){
          //check if returning any error and skip step?
        console.log(e);
      }
    },
    disabledBeforeToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const day = new Date(date).getDay();
      if (day === 0 || day === 6) return true;
      else if (date < today) return true;
      else return false;
    },
  },
};
</script>
<style scoped>
.mx-datepicker {
  display: block;
}
.flex-content-center {
  display: flex;
  justify-content: center;
}
</style>
